module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0152.jpg?v=5aa143a4";